import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {throwError} from 'rxjs';
import {OauthService} from './oauth.service';
import {APIURL} from './url.config';
import {delay, retryWhen, scan} from 'rxjs/operators';

/** Service for getting audit logs **/
@Injectable({
    providedIn: 'root'
})
export class AuditService {
    constructor(private http: HttpClient,
                private auth: OauthService) {}

    /** Handles errors */
    static handleError(error: Response) {
        return throwError(error.text() || 'Server error');
    }

    getAuditLogsV2(startDate, endDate) {
        return this.auth.getToken().then(token => {
            const authorization = 'bearer ' + token;
            const options = {
                headers: new HttpHeaders({Authorization: authorization})
            };

            return this.http.get<[]>(APIURL + 'api/audit_log/v2/?startDate=' + startDate + '&endDate=' + endDate, options)
                .pipe(retryWhen(errors => errors.pipe(scan((errorCount, err) => {
                    if (errorCount >= 3) {
                        throw err;
                    }
                    return errorCount + 1;
                }, 0)).pipe(delay(1000))))
                .toPromise();
        }).catch(AuditService.handleError);
    }

}